export default function Box({ children }) {
    return <div tw="p-0 shadow-none sm:(p-5 bg-white rounded shadow-updown)">{children}</div>;
}
